export default __webpack_public_path__ + "static/media/about-s-2.9a33445c.jpg";